import "./errorRoute.scss";

function ErrorRoute() {
  return <h1>Error Route</h1>;
}

export default ErrorRoute;
